/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_CharsInputs */

const en_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const fr_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const de_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const it_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const ru_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const es_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const zh_cn2_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const ja_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const hi_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

const pt_pt2_options_metrics_show_chars = /** @type {(inputs: Options_Metrics_Show_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Character Count Per Line`)
};

/**
* | output |
* | --- |
* | "Show Character Count Per Line" |
*
* @param {Options_Metrics_Show_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_chars = /** @type {((inputs?: Options_Metrics_Show_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_show_chars(inputs)
	if (locale === "de") return de_options_metrics_show_chars(inputs)
	if (locale === "it") return it_options_metrics_show_chars(inputs)
	if (locale === "ru") return ru_options_metrics_show_chars(inputs)
	if (locale === "es") return es_options_metrics_show_chars(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_show_chars(inputs)
	if (locale === "ja") return ja_options_metrics_show_chars(inputs)
	if (locale === "hi") return hi_options_metrics_show_chars(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_show_chars(inputs)
	return en_options_metrics_show_chars(inputs)
});